import { render, staticRenderFns } from "./pick-up-points.component.vue?vue&type=template&id=200321eb"
import script from "./pick-up-points.component.ts?vue&type=script&lang=ts&external"
export * from "./pick-up-points.component.ts?vue&type=script&lang=ts&external"
import style0 from "./pick-up-points.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports